<div class="flex align-items-center max-w-16rem">
  <div class="flex align-items-center justify-content-center">
    <i class="mr-2 {{ iconSize }} pi {{ file.mime | mime }}"></i>
  </div>
  <div>
    <a
      target="_blank"
      [href]="'file/' + file.path | apiUrl"
      download=""
      class="flex break-word">
      {{ file.name | truncate: 35 }}
    </a>
    <div
      class="text-400 text-sm"
      *ngIf="isShowFileSize">
      {{ file.size | bytes }}<ng-container *ngIf="created"> · {{ created | date: 'd MMM yyyy, HH:mm' }}</ng-container>
    </div>
  </div>
</div>
